import React, { useState, useEffect } from 'react';
import { TextField, PrimaryButton, Stack, DetailsList, DetailsListLayoutMode, SelectionMode, Selection, Dialog, DialogType, DialogFooter, DefaultButton, DatePicker } from '@fluentui/react';
import "./App.css"
import { FaRegCopy, FaCheck } from "react-icons/fa";
import { IoReload } from "react-icons/io5";
import { PublicClientApplication } from '@azure/msal-browser';
import Loading from './Loading';

const msalConfig = {
  auth: {
    clientId: 'fc20ec05-fa4a-4de9-b459-e4b1b00e7762',
    authority: 'https://login.microsoftonline.com/cf3767e0-0cba-4bd6-9e43-02cf44292a95',
    redirectUri: 'https://keypass.ioz.ch',
  },
};
const apiUrl = 'https://key-generator-functions.azurewebsites.net';

const formatter = new Intl.DateTimeFormat('de-ch', { day: '2-digit', month: '2-digit', year: 'numeric' });

const msalInstance = new PublicClientApplication(msalConfig);
const scopes = ["user.read"];
await msalInstance.initialize();

const Icon = ({ item }) => {
  const [copied, setCopied] = useState(false);
  const [isRefreshDialogVisible, setIsRefreshDialogVisible] = useState(false);


  const copyToClipboard = () => {
    navigator.clipboard.writeText(item.key)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 750);
      })
      .catch(err => console.error('Failed to copy key to clipboard:', err));
  };

  const RefreshKey = async () => {
    setIsRefreshDialogVisible(true);
  };

  const confirmRefreshKey = async () => {
    setIsRefreshDialogVisible(false);

    try {
      const requestBody = {
        id: item.id,
        validFrom:item.validFrom,
        validUntil:item.validUntil
      };

      const response = await fetch(apiUrl + '/api/UpdateKey?code=oPUbSJRHad5cQ6YH5JYtZdMQ4iyFFYZwpaXVwEcd7OEyAzFuWEzZUA==', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      window.location.reload();

    } catch (error) {
      console.error("Error fetching keys:", error);
    }
  };



  return (
    <>
      {copied ? (
        <>
          <FaCheck size={15} className="icon-margin" />
          <IoReload size={15} onClick={RefreshKey} />
        </>
      ) : (
        <>
          <FaRegCopy size={15} onClick={copyToClipboard} className="icon-margin" />
          <IoReload size={15} onClick={RefreshKey} />
        </>
      )}
      <Dialog
        hidden={!isRefreshDialogVisible}
        onDismiss={() => setIsRefreshDialogVisible(false)}
        dialogContentProps={{
          type: DialogType.normal,
          title: 'Bestätigung',
          subText: 'Möchtest du den Key aktualisieren?',
        }}
        modalProps={{
          isBlocking: false,
        }}
      >
        <DialogFooter>
          <PrimaryButton onClick={confirmRefreshKey} text="Ja" />
          <DefaultButton onClick={() => setIsRefreshDialogVisible(false)} text="Nein" />
        </DialogFooter>
      </Dialog>
    </>
  );
}

function App() {

  const [key, setKey] = useState('');
  const [copySuccess, setCopySuccess] = useState('');
  const [items, setItems] = useState([]);
  const [groups, setGroups] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [msalToken, setMsalToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isDeleteDialogVisible, setIsDeleteDialogVisible] = useState(false);

  const [validFrom, setValidFrom] = useState(null);
  const [validUntil, setValidUntil] = useState(null);
  const [company, setCompany] = useState(null);
  const [product, setProduct] = useState(null);
  const [formIsVisible, setFormIsVisible] = useState(false);
  const [updateFormIsVisible, setUpdateFormIsVisible] = useState(false);
  const [itemToUpdate, setItemToUpdate] = useState(null);




  const columns = [
    { key: 'column1', name: 'Produkt', fieldName: 'product', minWidth: 100, maxWidth: 200, isResizable: true },
    { key: 'column2', name: 'Key', fieldName: 'key', minWidth: 300, maxWidth: 300, isResizable: true },
    { key: 'column4', name: 'gültig von', fieldName: 'validFromShow', minWidth: 200, maxWidth: 200, isResizable: true },
    { key: 'column5', name: 'gültig bis', fieldName: 'validUntilShow', minWidth: 200, maxWidth: 200, isResizable: true },
    {
      key: 'column3',
      name: '',
      minWidth: 75,
      maxWidth: 75,
      isResizable: true,
      onRender: (item) => {
        return <Icon item={item} />;
      },
    }
  ];

  const handleLogin = async () => {
    if (!msalToken) {
      try {
        const tokenResponse = await msalInstance.handleRedirectPromise();
        if (tokenResponse) {
          msalInstance.setActiveAccount(tokenResponse.account);
          window.location.reload();
        } else {
          msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
        }

        const account = msalInstance.getActiveAccount();
        if (account && tokenResponse) {
          console.log("[AuthService] Got valid accountObj and tokenResponse");
          setMsalToken(tokenResponse.accessToken);
        } else if (account) {
          console.log("[AuthService] User has logged in, but no tokens.");
          try {
            const silentTokenResponse = await msalInstance.acquireTokenSilent({ account, scopes });
            setMsalToken(silentTokenResponse.accessToken);
            console.log("[AuthService] Token acquired")
          } catch (error) {
            console.log("[AuthService] Token could not be acquired silently");
            await msalInstance.acquireTokenRedirect({ account, scopes });
          }
        } else {
          console.log("[AuthService] No accountObject or tokenResponse present. User must now login.");
          await msalInstance.loginRedirect({ scopes });
        }
      } catch (error) {
        console.error("[AuthService] Failed to handleRedirectPromise()", error);
      }
      finally {
        setIsLoading(false);
      }
    }
    else {
      setIsLoading(false);
    }
  };

  const fetchKeys = async () => {
    try {
      const response = await fetch(apiUrl + '/api/GetKeys?code=Ha38A9OhIQNz1jAsFhwRBXYYJHBfEyCcFDlXLAAcM3QVAzFu9ArrbQ==');
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
        data.map((k) => {
              if(k.validFrom!= null){
            const from = new Date(k.validFrom);
            k.validFromShow = formatter.format(from);
          }
          if(k.validUntil != null){
            const until = new Date(k.validUntil);
            k.validUntilShow = formatter.format(until);
          }
        })
      setItems(data);
    } catch (error) {
      console.error("Error fetching keys:", error);
    }
  };

  const createGroups = (items) => {
    const groupMap = {};
    items.forEach(item => {
      groupMap[item.company] = groupMap[item.company] || [];
      groupMap[item.company].push(item);
    });

    let startIndex = 0;
    const groups = Object.keys(groupMap).map(company => {
      const group = {
        key: company,
        name: company,
        startIndex: startIndex,
        count: groupMap[company].length,
        level: 0,
      };
      startIndex += group.count;
      return group;
    });

    return groups;
  };

  useEffect(() => {
    handleLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchKeys();
  }, [key]);

  useEffect(() => {
    const sortedItems = items.sort(function (a, b) {
      if (a.company < b.company) return -1;
      if (a.company > b.company) return 1;
      return 0;
    })

    const newGroups = createGroups(sortedItems);
    setGroups(newGroups);
  }, [items, key]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(key).then(
      () => {
        setCopySuccess('Key kopiert!');
        setTimeout(() => setCopySuccess(''), 3000);
      },
      (err) => {
        console.error('Error in copying text: ', err);
      }
    );
  };

  const generateKey = async (event) => {
    event.preventDefault();

    const requestBody = {
      product: product,
      company: company,
      validFrom: validFrom,
      validUntil: validUntil
    };

    try {
      const response = await fetch(apiUrl + '/api/GenerateKey?code=sAkPWuXwpIeheqX9riW8G_-bhyh6LxxDNJRK7yxe58fZAzFuZHOwtA==', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const key = await response.json();
      setKey(key.key)
      setCompany("");
      setProduct("");
      setValidFrom(null);
      setValidUntil(null);
    } catch (error) {
      console.error("Error generating key:", error);
      setKey("Fehler")
    }
  };

  const updateKey = async() => {
    const requestBody = {
      id: selectedItems[0].id,
      validFrom: itemToUpdate.validFrom,
      validUntil: itemToUpdate.validUntil
    };
     try {
      const response = await fetch(apiUrl + '/api/UpdateKey?code=sAkPWuXwpIeheqX9riW8G_-bhyh6LxxDNJRK7yxe58fZAzFuZHOwtA==', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });
      setValidFrom(null);
      setValidUntil(null);
      fetchKeys();
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }      
    } catch (error) {
      console.error("Error generating key:", error);
      setKey("Fehler")
    }
  }

  const selection = new Selection({
    onSelectionChanged: () => {
      setSelectedItems(selection.getSelection());
      setUpdateFormIsVisible(false);
      setFormIsVisible(false);
    }
  });

  const confirmDeletion = async () => {
    setIsDeleteDialogVisible(false);

    if (selectedItems.length === 0) {
      return;
    }

    const idToDelete = selectedItems[0];

    try {
      const response = await fetch(apiUrl + '/api/DeleteKey?code=tfu_FR9jGCHgi2Qs3sujXewtICJqu_SRdqaVO72yvGR9AzFuzfzCRA==', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(idToDelete)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const remainingItems = await response.json();
      setItems(remainingItems);
      setSelectedItems([]);

    } catch (error) {
      console.error("Error deleting keys:", error);
    }
  };


  const deleteSelection = () => {
    if (selectedItems.length === 0) {
      return;
    }
    setIsDeleteDialogVisible(true);
  };

  const onShowUpdateForm = () => {
    setUpdateFormIsVisible(!updateFormIsVisible); 
    setFormIsVisible(false);
    setItemToUpdate({
      id: selectedItems[0].id,
      company: selectedItems[0].company,
      validFrom: selectedItems[0].validFrom ? new Date(selectedItems[0].validFrom):null,
      validUntil:selectedItems[0].validUntil ? new Date(selectedItems[0].validUntil):null
    })

  }

  const onFormatDate = (date) => {
    return formatter.format(date);
  };

  return (
    isLoading || !msalToken ?
      <Loading /> :
      (
        <Stack horizontalAlign="center" verticalFill>
          <Stack vertical tokens={{ childrenGap: 50 }} verticalAlign="center" className="innerContainer" horizontalAlign='center'>
            <Stack horizontalAlign='space-between' horizontal className='buttonStack'>
                <PrimaryButton text='Neu +' onClick={() => {setFormIsVisible(!formIsVisible); setUpdateFormIsVisible(false); setValidFrom(null);setValidUntil(null)}}/>
                  <Stack horizontal tokens={{childrenGap:15}}>
                    <PrimaryButton text='Update Key' onClick={onShowUpdateForm} disabled={selectedItems.length === 0}/>
                    <PrimaryButton text="Auswahl löschen" onClick={deleteSelection} disabled={selectedItems.length === 0} />
                  </Stack>
            </Stack>
            {formIsVisible &&
              <Stack tokens={{ childrenGap: 15 }} verticalAlign='center' className="formContainer">
                <Stack horizontal tokens={{ childrenGap: 15 }}>
                  <Stack.Item grow={3}>
                    <TextField className="inputField" label="Unternehmen" id="company" value={company} onChange={(e,newValue) => setCompany(newValue)}/>
                    <TextField className="inputField" label="Produkt" id="product" value={product} onChange={(e, newValue)=> setProduct(newValue)}/>
                  </Stack.Item>
                  <Stack.Item grow={1}>
                    <DatePicker className="inputField" label="Gültig von" id="validFrom"  value={validFrom} onSelectDate={( date)=> setValidFrom(date)} formatDate={onFormatDate}/>
                    <DatePicker className="inputField" label="Gültig bis" id="validUntil"  value={validUntil} onSelectDate={(date)=> setValidUntil(date)} formatDate={onFormatDate}/>
                  </Stack.Item>
                </Stack>
                <Stack.Item>
                <Stack horizontalAlign='end'>
                  <PrimaryButton onClick={generateKey} text="Key erstellen" />
                </Stack>
                {key && (
                  <div onClick={copyToClipboard} className="keyDisplay">
                    {key}
                  </div>
                )}
                {copySuccess && <div className="copySuccess">{copySuccess}</div>}
                </Stack.Item>
              </Stack>
              }
              {updateFormIsVisible &&
              <Stack tokens={{ childrenGap: 15 }} verticalAlign='center' className="formContainer">
                <Stack horizontal tokens={{ childrenGap: 15 }}>
                  <Stack.Item grow={3}>
                    <TextField className="inputField" label="Unternehmen" readOnly id="companyUpdate" value={selectedItems[0].company} onChange={(e,newValue) => setCompany(newValue)}/>
                    <TextField className="inputField" label="Produkt" readOnly id="productUpdate" value={selectedItems[0].product} onChange={(e, newValue)=> setProduct(newValue)}/>
                  </Stack.Item>
                  <Stack.Item grow={1}>
                    <DatePicker className="inputField" label="Gültig von" id="validFromUpdate"  value={itemToUpdate.validFrom} onSelectDate={( date)=> setItemToUpdate((itemToUpdate) => {itemToUpdate.validFrom = date; return itemToUpdate})} formatDate={onFormatDate}/>
                    <DatePicker className="inputField" label="Gültig bis" id="validUntilUpdate"  value={itemToUpdate.validUntil} onSelectDate={(date)=> setItemToUpdate((itemToUpdate) => {itemToUpdate.validUntil = date; return itemToUpdate})} formatDate={onFormatDate}/>
                  </Stack.Item>
                </Stack>
                <Stack.Item>
                <Stack horizontalAlign='end'>
                  <PrimaryButton onClick={updateKey} text="Update" />
                </Stack>
                </Stack.Item>
              </Stack>
              }
            <Stack.Item align="center" className="detailsListContainer">  
              <DetailsList
                items={items}
                columns={columns}
                groups={groups}
                layoutMode={DetailsListLayoutMode.justified}
                enterModalSelectionOnTouch={true}
                selectionMode={SelectionMode.single}
                selection={selection}
              />
            </Stack.Item>
          </Stack>
          <Dialog
            hidden={!isDeleteDialogVisible}
            onDismiss={() => setIsDeleteDialogVisible(false)}
            dialogContentProps={{
              type: DialogType.normal,
              title: 'Bestätigung',
              subText: 'Möchtest du den ausgewählten Key löschen?',
            }}
            modalProps={{
              isBlocking: false,
            }}
          >
          <DialogFooter>
            <PrimaryButton onClick={confirmDeletion} text="Ja" />
            <DefaultButton onClick={() => setIsDeleteDialogVisible(false)} text="Nein" />
          </DialogFooter>
        </Dialog>
      </Stack>
    )
  );
}

export default App;
